import React, { useEffect, useState } from "react";
import { AiFillDelete } from "react-icons/ai";
import { FaEdit } from "react-icons/fa";
import { Link } from "react-router-dom";
import LoadingData from "../../Common/LoadingData";
import DeleteConfirmation from "../Layout/DeleteConfirmation";



const AllUsers = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [deleteMsg, setDeleteMsg] = useState(false);
  const [deleteId, setDeleteId] = useState();

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BASE_URL}/admin/users`, {
      method: "GET",
      credentials: "include",
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        console.log("Users data:", data);
        setData(data.msg);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const handleDelete = (id) => {
    fetch(`${process.env.REACT_APP_BASE_URL}/admin/user/${id}`, {
      method: "DELETE",
      credentials: "include",
    })
      .then((data) => data.json())
      .then((res) => {
        if (res.status === "success") {
          setData(data.filter((item) => item._id !== id));
          setDeleteMsg(false);
        } else {
          alert(res.msg);
        }
      });
  };

  if (loading) {
    return (
      <div style={{ width: "", textAlign: "center", marginTop: "300px" }}>
        <div className="lds-dual-ring"></div>
      </div>
    );
  }

  return (
    <div className="add-page">
      {deleteMsg && (
        <DeleteConfirmation
          deleteId={deleteId}
          handleDelete={handleDelete}
          setDeleteMsg={setDeleteMsg}
        />
      )}
      <table>
        <caption>All Users</caption>
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Membership</th>
            <th>Memberplan</th>
            <th>Delete</th>
            <th>Edit</th>
          </tr>
        </thead>
        <tbody>
          {data?.map((item, index) => (
            <tr key={index}>
              <td>{`${item.first_name} ${item.last_name}`}</td>
              <td>{item.email}</td>
              <td>{item.membership}</td>
              <td>{item?.memberplan}</td>
              <td>
                {/* <span className="delete" onClick={() => setShowConfirm(true)}>
                  <AiFillDelete />
                </span> */}
                <span
                  className="delete"
                  onClick={() => {
                    setDeleteId({
                      id: item._id,
                      name: `${item.first_name} ${item.last_name}`,
                    });
                    setDeleteMsg(true);
                  }}
                >
                  <AiFillDelete />
                </span>
              </td>
              <td>
                <Link to={`/dashboard/edit-user/${item._id}`}>
                  <span className="edit">
                    <FaEdit />
                  </span>
                </Link>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AllUsers;
